/**
 * A whole string that is one hyphenated UUID.
 *
 * The match is the entire value. A prefix, a suffix, or another path segment
 * fails, so `../` and `uuid/file` are not UUIDs. Hex may be either case.
 * Braces and the `urn:uuid:` form do not match.
 *
 * The third group's first digit is the version and must be 1–8. The fourth
 * group's first digit is the variant and must be 8, 9, a, or b (the RFC 4122
 * variant). `crypto.randomUUID()` matches. The nil UUID does not, because its
 * version digit is 0.
 *
 * @example
 * EXACT_UUID_PATTERN.test('11111111-1111-4111-8111-111111111111'); // true
 * EXACT_UUID_PATTERN.test('../11111111-1111-4111-8111-111111111111'); // false
 */
export const EXACT_UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
